// import { Injectable } from '@angular/core';
// import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
// import { NgxSpinnerService } from 'ngx-spinner';
// import { Observable, throwError } from 'rxjs';
// import { map, catchError } from 'rxjs/operators';

// @Injectable()
// export class AppInterceptor implements HttpInterceptor {
//     constructor( private spinner: NgxSpinnerService) {}
  
//     intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

//         this.spinner.show();

//         return next.handle(req).pipe(map((event: HttpEvent<any>) => {
//             if (event instanceof HttpResponse) {
//               this.spinner.hide();
//             }
//             return event;
//           }),
//           catchError((error: HttpErrorResponse) => {
//             const started = Date.now();            
//             const elapsed = Date.now() - started;
//             console.log(`Request for ${req.urlWithParams} failed after ${elapsed} ms.`);
//            // debugger;
//             return throwError(error);
//           })
//         );

//     }  
// }
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class AppInterceptor implements HttpInterceptor {
  constructor(private spinner: NgxSpinnerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.spinner.show();

    // Exclude the login URL or any specific API you don't want to add the token to
    
    if (req.url.includes('login') ) {
      // If the request is a login or auth request, do not add the token.
      return next.handle(req).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.spinner.hide();
          }
          return event;
        }),
        catchError((error: HttpErrorResponse) => {
          this.spinner.hide();
          return throwError(error);
        })
      );
    } else {
      // Retrieve the token if it's not a login request
      const authToken = localStorage.getItem('user_token');
      
      // If the token exists, clone the request and add the Authorization header
      if (authToken) {
        const clonedRequest = req.clone({
          setHeaders: {
            Authorization: `Bearer ${authToken}`
          }
        });
        
        return next.handle(clonedRequest).pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              this.spinner.hide();
            }
            return event;
          }),
          catchError((error: HttpErrorResponse) => {
            this.spinner.hide();
            return throwError(error);
          })
        );
      } else {
        // If no token, proceed without modifying the request
        return next.handle(req).pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              this.spinner.hide();
            }
            return event;
          }),
          catchError((error: HttpErrorResponse) => {
            this.spinner.hide();
            return throwError(error);
          })
        );
      }
    }
  }
}
